import React, { useEffect, useState } from "react";
import { getBranchOrders, getBranchOrdersByBranch, getBranches } from "../../function/branch";
import { listProduct } from "../../function/product";
import OrderPopup from "./OrderPopup";
import { Pagination } from "antd"; // ✅ ใช้ Pagination ของ antd

import axios from "axios";

const BranchOrderList = () => {

  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [userRole, setUserRole] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(5);

  const [editingOrder, setEditingOrder] = useState(null);
  const [newReceiptDate, setNewReceiptDate] = useState("");

  const [formData, setFormData] = useState({
    username: "",
    phoneNumber: "",
    idCard: "",
    address: "",
    note: "",
    orderStatus: "",
    paymentMethod: "",
    receiptDate: "",
  });
  useEffect(() => {
    loadUserRole();
    loadBranches();
    loadOrders();
  }, []);

  const loadProducts = async () => {
    try {
      const { data } = await listProduct(100);
      setProducts(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const loadUserRole = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.role) {
        setUserRole(user.role);
        if (user.role === "staff") {
          setSelectedBranch(user.branch?._id || "");
        }
      }
    } catch (error) {
      console.error("Error fetching user role:", error);
    }
  };

  const loadOrders = async (branchId = "") => {
    try {
      setLoading(true);
      const authtoken = localStorage.getItem("token");
      let res;

      if (branchId) {
        res = await getBranchOrdersByBranch(authtoken, branchId);
      } else {
        res = await getBranchOrders(authtoken);
      }

      setOrders(res.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
      if (error.response && error.response.status === 401) {
        alert("คุณไม่มีสิทธิ์ดูออเดอร์ของสาขานี้");
      }
    } finally {
      setLoading(false);
    }
  };

  const loadBranches = async () => {
    try {
      const authtoken = localStorage.getItem("token");
      const { data } = await getBranches(authtoken);
      setBranches(data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const handleBranchChange = (e) => {
    const branchId = e.target.value;

    if (userRole === "staff") {
      alert("คุณไม่มีสิทธิ์เลือกสาขา");
      return;
    }
    console.log("Selected Branch ID:", branchId);
    setSelectedBranch(branchId);
    loadOrders(branchId);
  };

  // const handleEditDate = (order) => {
  //   setEditingOrder(order);
  //   setNewReceiptDate(order.receiptDate ? new Date(order.receiptDate).toISOString().split("T")[0] : "");
  // };


  // const handleUpdateDate = async (orderId) => {
  //   try {
  //     const authtoken = localStorage.getItem("token");
  //     const res = await axios.put(
  //       `${process.env.REACT_APP_API}/branch-order/${orderId}`,
  //       { receiptDate: newReceiptDate },
  //       {
  //         headers: { authtoken },
  //       }
  //     );
  //     alert("อัปเดตวันที่สำเร็จ!");
  //     setEditingOrder(null);
  //     loadOrders(); // โหลดคำสั่งซื้อใหม่
  //   } catch (error) {
  //     console.error("Error updating receipt date:", error);
  //     alert("เกิดข้อผิดพลาดในการอัปเดตวันที่");
  //   }
  // };


  const handleEditOrder = (order) => {
    setEditingOrder(order); // ✅ เก็บทั้ง object
    setFormData({
      username: order.username || "",
      phoneNumber: order.phoneNumber || "",
      idCard: order.idCard || "",
      address: order.address || "",
      note: order.note || "",
      orderStatus: order.orderStatus || "Not Process",
      paymentMethod: order.paymentMethod || "cash",
      receiptDate: order.receiptDate ? new Date(order.receiptDate).toISOString().split("T")[0] : "",
      cartTotal: order.cartTotal || 0,
      vat: order.vat || 0,
      items: order.items || [],
    });
  };

  useEffect(() => {
  if (formData.items && formData.items.length > 0) {
    // คำนวณราคารวมใหม่จาก items
    const total = formData.items.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.price) || 0;
      return sum + quantity * price;
    }, 0);

    // คำนวณ VAT (7%)
    const vatRate = 0.07;
    const totalWithoutVat = parseFloat((total / (1 + vatRate)).toFixed(2));
    const vat = parseFloat((total - totalWithoutVat).toFixed(2));

    // อัปเดตค่า formData
    setFormData((prev) => ({
      ...prev,
      cartTotal: parseFloat(total.toFixed(2)),
      vat: parseFloat(vat.toFixed(2)),
      totalWithoutVat: parseFloat(totalWithoutVat.toFixed(2)),
    }));
  }
}, [formData.items]);

  // บันทึกการแก้ไข
  const handleUpdateOrder = async () => {
    try {
      const authtoken = localStorage.getItem("token");
      await axios.put(
        `${process.env.REACT_APP_API}/branch-order/${editingOrder._id}`,
        formData,
        { headers: { authtoken } }
      );
      alert("อัปเดตคำสั่งซื้อสำเร็จ!");
      setEditingOrder(null);
      loadOrders(selectedBranch);
    } catch (error) {
      console.error("Error updating order:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดตคำสั่งซื้อ");
    }
  };
  // ตัดออเดอร์เฉพาะหน้าปัจจุบัน
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

  return (
    <div className="container mx-auto p-4 mt-5">
      <h2
        className="font-bold mb-4" // ยังคงใช้ className สำหรับการจัดการอื่น ๆ
        style={{ fontSize: "22px", }} // ปรับขนาดตัวอักษรและสี
      >
        รายการคำสั่งซื้อสาขา
      </h2>

      {/* Dropdown เลือกสาขา */}
      <div className="mb-4">
        <label className="mr-2 font-semibold">เลือกสาขา:</label>
        <select
          value={selectedBranch}
          onChange={handleBranchChange}
          className="border px-4 py-2 rounded"
          disabled={userRole === "staff"}
        >
          <option value="">ทั้งหมด</option>
          {branches.map((branch) => (
            <option key={branch._id} value={branch._id}>
              {branch.name}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <p>กำลังโหลดข้อมูล...</p>
      ) : (
        <>
          <table className="min-w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2">หมายเลขออเดอร์</th>
                <th className="border px-4 py-2">สาขา</th>
                {/* <th className="border px-4 py-2">สถานะ</th> */}
                <th className="border px-4 py-2">ผู้ทำรายการ</th>
                <th className="border px-4 py-2">วันที่</th>
                <th className="border px-4 py-2">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order) => (
                  <tr key={order._id} className="text-center">
                    <td className="border px-4 py-2">{order.orderNumber}</td>
                    <td className="border px-4 py-2">{order.branch?.name || "-"}</td>
                    {/* <td className="border px-4 py-2">{order.orderStatus}</td> */}
                    <td className="border px-4 py-2">{order.createdBy?.name || "-"}</td>
                    <td className="border px-4 py-2 text-left">
                      <div className="flex justify-between items-center">
                        {/* วันที่ */}
                        <span className="w-40">
                          {order.receiptDate
                            ? new Date(order.receiptDate).toLocaleDateString("th-TH", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                            : "-"}
                        </span>

                        {/* ปุ่มแก้ไข */}

                      </div>
                    </td>
                    <td className="border px-4 py-2 text-center">
                      {/* <button
                        onClick={() => setSelectedOrder(order)}
                        className="px-4 py-2 rounded bg-gray-700 text-white hover:bg-gray-800 transition duration-200"
                      >
                        ดูรายละเอียด
                      </button> */}
                      <button
                        onClick={() => setSelectedOrder(order)}
                        style={{ backgroundColor: "#6c757d", color: "white", border: "1px solid ", }} // สีเขียว
                        className="px-4 py-2 rounded"
                      >
                        ดูรายละเอียด
                      </button>
                      <button
                        onClick={() => handleEditOrder(order)}
                        style={{
                          backgroundColor: "#fff", // สีเดียวกับปุ่มดูรายละเอียด
                          color: "#6c757d",
                          border: "1px solid #fff",
                          marginLeft: "8px", // เพิ่มระยะห่างระหว่างปุ่ม
                          fontSize: "14px",
                          padding: "6px 16px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                        className="rounded"
                        title="แก้ไขวันที่"
                      >
                        ✏️ (แก้ไข)
                      </button>
                    </td>

                    {/* <td className="border px-4 py-2">
                      <button
                        onClick={() => handleEditDate(order)}
                        className="px-4 py-2 rounded bg-blue-500 text-white"
                      >
                        แก้ไขวันที่
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4">ไม่มีคำสั่งซื้อ</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* ✅ ใช้ Pagination ของ Ant Design */}
          <div className="flex justify-center mt-4">
            <Pagination
              current={currentPage}
              pageSize={ordersPerPage}
              total={orders.length}
              onChange={(page) => setCurrentPage(page)}
            />
          </div>
        </>
      )}
      {editingOrder && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-60 flex justify-center items-start pt-10 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6">
            <h2 className="text-2xl font-bold mb-4 text-center">แก้ไขคำสั่งซื้อ</h2>
            <p className="mb-4 text-gray-600 text-sm text-center">
              เลขที่คำสั่งซื้อ: <span className="font-semibold">{editingOrder.orderNumber}</span>
            </p>

            <form>
              {/* รายการสินค้า */}
              <div className="mb-4 mt-1">
                <label className="form-label font-medium">รายการสินค้า</label>
                {formData.items?.map((item, index) => (
                  <div key={index} className="row mb-3 align-items-end">
                    <div className="col-md-4 mt-1">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="ชื่อสินค้า"
                        value={item.customProduct || item.productTitle || ""}
                        onChange={(e) => {
                          const newItems = [...formData.items];
                          if (item.productTitle) newItems[index].productTitle = e.target.value;
                          else newItems[index].customProduct = e.target.value;
                          setFormData({ ...formData, items: newItems });
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="จำนวน"
                        value={item.quantity || ""}
                        onChange={(e) => {
                          const newItems = [...formData.items];
                          newItems[index].quantity = e.target.value;
                          setFormData({ ...formData, items: newItems });
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="ราคา"
                        value={item.price || ""}
                        onChange={(e) => {
                          const newItems = [...formData.items];
                          newItems[index].price = e.target.value;
                          setFormData({ ...formData, items: newItems });
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* ข้อมูลลูกค้าและคำสั่งซื้อ */}
              <div className="row g-3 mt-1">
                <div className="col-md-6">
                  <label className="form-label">ชื่อลูกค้า</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.username}
                    onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">เบอร์โทร</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.phoneNumber}
                    onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">ที่อยู่</label>
                  <textarea
                    className="form-control"
                    rows={2}
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">หมายเหตุ</label>
                  <textarea
                    className="form-control"
                    rows={2}
                    value={formData.note}
                    onChange={(e) => setFormData({ ...formData, note: e.target.value })}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">สถานะ</label>
                  <select
                    className="form-select"
                    value={formData.orderStatus}
                    onChange={(e) => setFormData({ ...formData, orderStatus: e.target.value })}
                  >
                    <option value="Not Process">Not Process</option>
                    <option value="Processing">Processing</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <label className="form-label">วิธีชำระเงิน</label>
                  <select
                    className="form-select"
                    value={formData.paymentMethod}
                    onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}
                  >
                    <option value="cash">Cash</option>
                    <option value="card">Card</option>
                    <option value="bankTransfer">Bank Transfer</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <label className="form-label">วันที่</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.receiptDate}
                    onChange={(e) => setFormData({ ...formData, receiptDate: e.target.value })}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">ยอดรวม</label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.cartTotal}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">VAT (7%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.vat}
                    readOnly
                  />
                </div>
              </div>

              {/* ปุ่ม */}
              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-danger me-2"
                  onClick={() => setEditingOrder(null)}
                >
                  ยกเลิก
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleUpdateOrder}
                >
                  บันทึก
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* แสดง Popup เมื่อเลือกออเดอร์ */}
      {selectedOrder && <OrderPopup order={selectedOrder} onClose={() => setSelectedOrder(null)} />}
    </div>
  );
};

export default BranchOrderList;
